var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditNote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-05",
    clipPath: "url(#clip0_1261_18504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.33398 2.66666H4.53398C3.41388 2.66666 2.85383 2.66666 2.426 2.88464C2.04968 3.07639 1.74372 3.38235 1.55197 3.75867C1.33398 4.1865 1.33398 4.74655 1.33398 5.86666V11.4667C1.33398 12.5868 1.33398 13.1468 1.55197 13.5746C1.74372 13.951 2.04968 14.2569 2.426 14.4487C2.85383 14.6667 3.41388 14.6667 4.53398 14.6667H10.134C11.2541 14.6667 11.8141 14.6667 12.242 14.4487C12.6183 14.2569 12.9243 13.951 13.116 13.5746C13.334 13.1468 13.334 12.5868 13.334 11.4667V8.66666M5.33397 10.6667H6.45033C6.77645 10.6667 6.93951 10.6667 7.09296 10.6298C7.22901 10.5972 7.35907 10.5433 7.47836 10.4702C7.61292 10.3877 7.72822 10.2724 7.95882 10.0418L14.334 3.66666C14.8863 3.11437 14.8863 2.21894 14.334 1.66666C13.7817 1.11437 12.8863 1.11437 12.334 1.66665L5.95881 8.04182C5.7282 8.27242 5.6129 8.38772 5.53045 8.52228C5.45734 8.64157 5.40347 8.77163 5.37081 8.90768C5.33397 9.06113 5.33397 9.22419 5.33397 9.55031V10.6667Z",
    stroke: "#111827",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1261_18504"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNote);
export default __webpack_public_path__ + "static/media/edit-note.76cf5238ebd74d8183fff96ada0d2b96.svg";
export { ForwardRef as ReactComponent };